import React from 'react';
import { QuestionMarkCircleIcon } from '@heroicons/react/24/solid';

interface GuideButtonProps {
  onClick: () => void;
}

const GuideButton: React.FC<GuideButtonProps> = ({ onClick }) => {
  return (
    <button
      onClick={onClick}
      className="flex items-center gap-1.5 px-3 py-1.5 bg-white/20 hover:bg-white/30 text-white  transition-all duration-200 text-sm font-medium border border-white/30"
    >
      <QuestionMarkCircleIcon className="h-5 w-5" />
      <span>Invoice Application Guide</span>
    </button>
  );
};

export default GuideButton;